"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var calcTimestampDelta = function calcTimestampDelta(serverTimestamp) {
  return _curTimestampInMicroSeconds() - _toInt(serverTimestamp);
};
var applyTimestampDelta = function applyTimestampDelta(serverTimestamp) {
  var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var result = _toInt(serverTimestamp) + _toInt(delta);
  return _toString(result);
};
var applyTimestampDeltaToDate = function applyTimestampDeltaToDate(serverDate) {
  var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!serverDate) return serverDate;
  var serverTimestamp = _toMicroSeconds(new Date(serverDate).getTime());
  var timestampWithDelta = applyTimestampDelta(serverTimestamp, delta);
  return new Date(_toMilliSeconds(timestampWithDelta)).toISOString();
};
var curTimestamp = function curTimestamp() {
  return _toString(_curTimestampInMicroSeconds());
};
var _toInt = function _toInt(value) {
  return parseInt(value, 10);
};
var _toString = function _toString(value) {
  return "" + value;
};
var _toMicroSeconds = function _toMicroSeconds(milliSeconds) {
  return _toInt(milliSeconds) * 1000;
};
var _toMilliSeconds = function _toMilliSeconds(microSeconds) {
  return _toInt(microSeconds) / 1000;
};
var _curTimestampInMicroSeconds = function _curTimestampInMicroSeconds() {
  return _toMicroSeconds(new Date().getTime());
};
exports.calcTimestampDelta = calcTimestampDelta;
exports.applyTimestampDelta = applyTimestampDelta;
exports.applyTimestampDeltaToDate = applyTimestampDeltaToDate;
exports.curTimestamp = curTimestamp;